import Paper from '@mui/material/Paper';
import { withStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import { useEffect, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { withTranslation } from 'react-i18next';
import { Form, reduxForm } from 'redux-form';
import { openRequestModal } from '../../actions/modals';
import { setNewHwHeight } from '../../actions/user';
import store from '../../store';
import * as ActionCreators from './../../actions/AsyncTable';
import Body from './Table/Body';
import FilterView from './Table/Filter/View';
import Head from './Table/Head';
import Header from './Table/Header';
import Pagination from './Table/Pagination';

import { Box, Typography } from '@mui/material';
import i18n from 'i18next';
import usePhoneCheck from '../../hooks/usePhoneCheck';

const styled = withStyles(() => ({
    tableWrapper: {
        overflowX: 'auto',
        maxHeight: '63vh',
    },
}));

const onSubmit = (data, dispatch, props) => {
    const { t } = props;
    const { callBackDataHW, path, exitAccept, touched, tableActual, tableCount, studentSelected } = props;
    const hasStudentsWithIHW = props.HW?.students_list?.some(s => s.ihw === true);
    if (
        !exitAccept &&
        path &&
        path.includes('/groups/:id/hw/:date') &&
        (!!touched || !(tableCount === tableActual) || hasStudentsWithIHW) &&
        callBackDataHW
    ) {
        openRequestModal({
            opened: true,
            data: {
                header: t('buttons.set'),
                modaltype: 'AcceptHwModal',
                student: studentSelected && `${studentSelected.first_name} ${studentSelected.last_name}`,
                acceptHandler: callBackDataHW,
                acceptHandlerData: data,
            },
        })(store.dispatch, store.getState);
    } else {
        callBackDataHW(data);
    }
};

const AsyncTable = props => {
    const currentTable = useMemo(() => {
        if (!props?.default || !props?.table) {
            return {};
        }
        return {
            ...JSON.parse(JSON.stringify(props.default)),
            ...props.table,
        };
    }, [props?.default, props?.table]);

    const {
        rowsPerPageOptions,
        count,
        rowsPerPage,
        page,
        model,
        filter,
        data,
        cities,
        flagUpdate,
        subdivisions,
        counterparties,
        ordersStatusList,
        fetching,
        isEmpty,
        expanded,
        sort,
        custom_filter,
    } = currentTable;

    const {
        __RowsPerPage,
        __ChangePage,
        __ChangeSort,
        __SetFilterValues,
        __GetData,
        __GetModel,
        __SetFilter,
        __ExpandFilterView,
        __RollUpFilterView,
        __typePayments,
        __sumPayments,
        t,
    } = props;

    const {
        actionsButton,
        blockOptions,
        classes,
        headerTable,
        enableFilter,
        actions = [],
        source,
        userData = false,
        typeTable,
        handleSubmit,
        callBackDataHW = null,
        fetchOnFilter,
        bankStudents,
        bankStudentsVip,
    } = props;

    const { newHwHeight, info, emulation } = useSelector(state => state.user);
    const hideSubmitButton = useSelector(state => state.HW.hideSubmitButton);
    const userId = emulation.length ? emulation[emulation.length - 1].user_id : info.user_id;
    const userKey = emulation.length ? `${userId}_emul` : userId;
    const endpoint = window.location.pathname;
    const hasFilterCriteria = custom_filter?.[userKey]?.[endpoint]?.length > 0;

    useEffect(() => {
        props.__Init(props.source, props.fetchOnFilter, props.reset);

        return () => {
            props.__Destroy();
        };
    }, []);

    useEffect(() => {
        if (flagUpdate) {
            __GetModel(source, fetchOnFilter);
        }
    }, [flagUpdate]);

    const headerActions = useMemo(() => {
        const array = actionsButton && actionsButton.length ? actionsButton : [];
        return array.map(action => {
            const { title, Icon, onClick, newEqualizer, outOfMenu } = action;
            return {
                title,
                Icon,
                onClick,
                newEqualizer,
                outOfMenu,
            };
        });
    }, [actionsButton]);

    const filterModel = useMemo(() => {
        if (typeof typeTable === 'string' && typeTable === 'payments') {
            return [
                ...model,
                {
                    type: 'string',
                    code: 'email',
                    label: i18n.t('table.email'),
                },
            ];
        }

        const hasFranchControl = actions?.some(action => action.franchControl === true);
        if (hasFranchControl) {
            return [
                ...model,
                {
                    type: 'franch_status_select',
                    code: 'status',
                    label: i18n.t('table.status'),
                },
            ];
        }

        return [...model];
    }, [typeTable, model]);

    const goldUser = useMemo(() => {
        const goldUserInfo = props.HW.students_list.find(el => {
            return el.first_name === 'Group' && el.last_name === 'Group';
        });
        const goldUser = !!(props.HW.students_list?.length && goldUserInfo && goldUserInfo.id === props.HW.student);
        return goldUser;
    }, [props.HW.students_list, props.HW.student]);

    const mobile = usePhoneCheck();

    return typeTable === 'HW' || typeTable === 'journal' || typeTable === 'promoVisits' ? (
        <Paper className={'componentTable'}>
            <Form onSubmit={handleSubmit}>
                <Header title={headerTable} actions={!!model.length ? headerActions : []} />
                {mobile ? (
                    <div>
                        <Head
                            fetching={fetching}
                            typeTable={typeTable}
                            userData={userData}
                            data={data}
                            t={t}
                            __ChangeSort={code => __ChangeSort(source, code)}
                            order={sort.order}
                            orderBy={sort.orderBy}
                            model={model}
                            hasActions={!!actions.length}
                            goldUser={goldUser}
                        />
                        <Body
                            typeTable={typeTable}
                            fetching={fetching}
                            actions={actions}
                            rowsCount={rowsPerPage}
                            model={model}
                            userData={userData}
                            data={data}
                            payType={__typePayments}
                            paySum={__sumPayments}
                            goldUser={goldUser}
                            bankStudents={bankStudents}
                            bankStudentsVip={bankStudentsVip}
                        />
                    </div>
                ) : (
                    <div className={classes.tableWrapper}>
                        <Table>
                            <Head
                                fetching={fetching}
                                typeTable={typeTable}
                                userData={userData}
                                data={data}
                                t={t}
                                __ChangeSort={code => __ChangeSort(source, code)}
                                order={sort.order}
                                orderBy={sort.orderBy}
                                model={model}
                                hasActions={!!actions.length}
                                goldUser={goldUser}
                            />
                            <Body
                                typeTable={typeTable}
                                fetching={fetching}
                                actions={actions}
                                rowsCount={rowsPerPage}
                                model={model}
                                userData={userData}
                                data={data}
                                payType={__typePayments}
                                paySum={__sumPayments}
                                goldUser={goldUser}
                                bankStudents={bankStudents}
                                bankStudentsVip={bankStudentsVip}
                            />
                        </Table>
                    </div>
                )}

                <Box p={3}>
                    {(window.location.pathname.includes('/template') ? !hideSubmitButton : true) && callBackDataHW ? (
                        <Button variant="contained" color="primary" type="submit">
                            {props.HW.load ? (
                                <CircularProgress size={24} color="inherit" />
                            ) : window.location.pathname.includes('/template') || typeTable === 'promoVisits' ? (
                                t('buttons.save')
                            ) : (
                                t('buttons.set')
                            )}
                        </Button>
                    ) : null}

                    {callBackDataHW && mobile && newHwHeight !== null ? (
                        <IconButton
                            aria-label="delete"
                            className="toPrewBlockButton"
                            onClick={() => setNewHwHeight()(store.dispatch, store.getState)}
                        >
                            <ArrowUpwardIcon />
                        </IconButton>
                    ) : null}
                </Box>
            </Form>
        </Paper>
    ) : (
        <Paper className={'componentTable'}>
            <div>
                <Header
                    title={headerTable}
                    filterActive={!!filter.length}
                    actions={!!model.length ? headerActions : []}
                />
                {enableFilter &&
                    !!model.length &&
                    !fetching &&
                    (data?.length || hasFilterCriteria || expanded || typeTable === 'Support' || typeTable === "paymentsSupport" ? (
                        <FilterView
                            filter={filter}
                            source={source}
                            onAccept={newFilter => {
                                __SetFilterValues()(newFilter);
                                __GetData(source, true, fetchOnFilter);
                            }}
                            model={filterModel}
                            cities={cities}
                            subdivisions={subdivisions}
                            counterparties={counterparties}
                            ordersStatusList={ordersStatusList}
                            expanded={expanded}
                            setFilterValues={__SetFilter()}
                            expandFilterView={__ExpandFilterView()}
                            rollUpFilterView={__RollUpFilterView()}
                            fetchOnFilter={props.fetchOnFilter}
                        />
                    ) : (
                        <Typography style={{ textAlign: 'center', padding: '1rem' }}>
                            {typeTable === 'moneybox' ? t('transactionsHistory.emptyData') : t('text.noDataYetMessage')}
                        </Typography>
                    ))}
                {mobile ? (
                    <div>
                        <Head
                            fetching={fetching}
                            typeTable={typeTable}
                            userData={userData}
                            data={data}
                            t={t}
                            __ChangeSort={code => __ChangeSort(source, code)}
                            order={sort.order}
                            orderBy={sort.orderBy}
                            model={model}
                            hasActions={!!actions.length}
                            goldUser={goldUser}
                        />
                        <Body
                            typeTable={typeTable}
                            fetching={fetching}
                            actions={actions}
                            rowsCount={rowsPerPage}
                            model={model}
                            userData={userData}
                            data={data}
                            payType={__typePayments}
                            paySum={__sumPayments}
                            goldUser={goldUser}
                            bankStudents={bankStudents}
                            bankStudentsVip={bankStudentsVip}
                        />
                    </div>
                ) : (
                    <div className={classes.tableWrapper}>
                        <Table stickyHeader>
                            <Head
                                fetching={fetching}
                                typeTable={typeTable}
                                userData={userData}
                                data={data}
                                t={t}
                                __ChangeSort={code => __ChangeSort(source, code)}
                                order={sort.order}
                                orderBy={sort.orderBy}
                                model={model}
                                hasActions={!!actions.length}
                                goldUser={goldUser}
                            />
                            <Body
                                typeTable={typeTable}
                                fetching={fetching}
                                actions={actions}
                                rowsCount={rowsPerPage}
                                model={model}
                                userData={userData}
                                data={data}
                                payType={__typePayments}
                                paySum={__sumPayments}
                                goldUser={goldUser}
                                bankStudents={bankStudents}
                                bankStudentsVip={bankStudentsVip}
                            />
                        </Table>
                    </div>
                )}
                {!isEmpty && !blockOptions && (
                    <Pagination
                        rowsPerPageOptions={rowsPerPageOptions}
                        count={count}
                        t={t}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={__ChangePage(source)}
                        onRowsPerPageChange={__RowsPerPage(source)}
                        disabled={fetching}
                    />
                )}
            </div>
        </Paper>
    );
};

function initialValues(state) {
    const data = (state.AsyncTable && state.AsyncTable.table && state.AsyncTable.table.data) || [];
    const initialData = {};
    for (let i in data) {
        for (var key in data[i]) {
            initialData[JSON.stringify({ code: key, id: data[i].id })] = data[i][key];
        }
    }
    return initialData;
}

const mapStateToProps = state => ({
    ...state.AsyncTable,
    initialValues: initialValues(state),
    user: state.user,
    HW: state.HW,
});

const mapDispatchToProps = dispatch => bindActionCreators(ActionCreators, dispatch);
let withForm = styled(AsyncTable);

withForm = reduxForm({
    enableReinitialize: true,
    onSubmit,
    form: 'from-tableComponent', // a unique identifier for this form
})(withForm);

withForm = connect(mapStateToProps, mapDispatchToProps)(withForm);

export default withTranslation()(withForm);
